import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

const options = {
  color: '#2a3f54',
  failedColor: '#874b4b',
  thickness: '3px',
};

Vue.use(VueProgressBar, options);
